document.addEventListener('DOMContentLoaded', function() {
  const forms = document.querySelectorAll('form[class="form"]');
  console.log('Forms found:', forms.length); // Debug: Check if forms are detected

  forms.forEach(form => {
    const firstNameInput = form.querySelector('.wac-first-name');
    const lastNameInput = form.querySelector('.wac-last-name');
    const emailInput = form.querySelector('.wac-email');
    const passwordInput = form.querySelector('.wac-password');
    const mobileInput = form.querySelector('.wac-mobile');
    const addressInput = form.querySelector('.wac-address');
    const cityInput = form.querySelector('.wac-city');
    const countryInput = form.querySelector('.wac-country');
    const zipcodeInput = form.querySelector('.wac-zipcode');
    const submitButton = form.querySelector('input[type="submit"], button[type="submit"], button[type="button"]');
    console.log('Form inputs:', { firstNameInput, lastNameInput, emailInput, passwordInput, mobileInput, addressInput, cityInput, countryInput, zipcodeInput }); // Debug: Check input elements

    function removeErrorMessage(parentElement, errorId) {
      const existingError = parentElement.querySelector(`#${errorId}`);
      if (existingError) existingError.remove();
    }

    function showErrorMessage(element, errorId, message) {
      removeErrorMessage(element.parentNode, errorId);
      const errorDiv = document.createElement('div');
      errorDiv.id = errorId;
      errorDiv.className = 'validation-error';
      errorDiv.textContent = message;
      element.parentNode.appendChild(errorDiv);
    }

    // First Name validation
    if (firstNameInput) {
      firstNameInput.addEventListener('keydown', function (e) {
        const key = e.key;
        const value = firstNameInput.value;
        const cursorPos = firstNameInput.selectionStart;

        const isLetter = /^[a-zA-Z]$/.test(key);
        const isSpace = key === ' ';
        
        const prevChar = value[cursorPos - 1] || '';

        if (
          (!isLetter && !isSpace && key.length === 1) ||
          (isSpace && (cursorPos === 0 || prevChar === ''))
        ) {
          e.preventDefault();
        }
      });

      firstNameInput.addEventListener('input', function () {
        let value = firstNameInput.value;
        value = value.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ').replace(/^\s+|\s+$/g, '');
        if (firstNameInput.value !== value) {
          firstNameInput.value = value;
        }

        if (value === '') {
          showErrorMessage(firstNameInput, 'firstNameError', 'First name is required');
        } else if (value.length < 3) {
          showErrorMessage(firstNameInput, 'firstNameError', 'Please enter at least 3 characters');
        } else {
          removeErrorMessage(firstNameInput.parentNode, 'firstNameError');
        }
      });
    }

    // Last Name validation
    if (lastNameInput) {
      lastNameInput.addEventListener('keydown', function (e) {
        const key = e.key;
        const value = lastNameInput.value;
        const cursorPos = lastNameInput.selectionStart;

        const isLetter = /^[a-zA-Z]$/.test(key);
        const isSpace = key === ' ';
        const prevChar = value[cursorPos - 1] || '';

        if (
          (!isLetter && !isSpace && key.length === 1) ||
          (isSpace && (cursorPos === 0 || prevChar === ''))
        ) {
          e.preventDefault();
        }
      });

      lastNameInput.addEventListener('input', function () {
        const value = lastNameInput.value;
        if (value === '') {
          showErrorMessage(lastNameInput, 'lastNameError', 'Last name is required');
        } else {
          removeErrorMessage(lastNameInput.parentNode, 'lastNameError');
        }
      });
    }

    // Email validation
    if (emailInput) {
      emailInput.addEventListener('keydown', function (e) {
        const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab', '.', '-', '_', '@'];
        const isLetterOrDigit = /^[a-zA-Z0-9]$/.test(e.key);

        if (!isLetterOrDigit && !allowedKeys.includes(e.key)) {
          e.preventDefault();
        }

        if (e.key === '@') {
          const value = emailInput.value;
          if (value.includes('@')) {
            e.preventDefault();
          }
        }
      });

      emailInput.addEventListener('paste', function (e) {
        e.preventDefault();
        const pastedText = (e.clipboardData || window.clipboardData).getData('text');
        const sanitizedText = pastedText.replace(/[^a-zA-Z0-9.@_-]/g, '').replace(/\s/g, '');
        const selectionStart = emailInput.selectionStart;
        const selectionEnd = emailInput.selectionEnd;
        const currentValue = emailInput.value;
        // Replace selected text or insert at cursor position
        emailInput.value = currentValue.slice(0, selectionStart) + sanitizedText + currentValue.slice(selectionEnd);
        emailInput.dispatchEvent(new Event('input'));
      });

      emailInput.addEventListener('input', function () {
        const value = emailInput.value.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const atCount = (value.match(/@/g) || []).length;

        if (value === '') {
          showErrorMessage(emailInput, 'emailError', 'Email is required');
        } else if (atCount > 1) {
          showErrorMessage(emailInput, 'emailError', 'Please enter a valid email address');
        } else if (!emailRegex.test(value)) {
          showErrorMessage(emailInput, 'emailError', 'Please enter a valid email address');
        } else {
          removeErrorMessage(emailInput.parentNode, 'emailError');
        }
      });
    }

    // Password validation
    if (passwordInput) {
      passwordInput.addEventListener('input', function() {
        const value = passwordInput.value;
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,40}$/;

        if (value === '') {
          showErrorMessage(passwordInput, 'passwordError', 'Password is required');
        } else if (value.length < 8 || value.length > 40) {
          showErrorMessage(passwordInput, 'passwordError', 'Password must be 8-40 characters long');
        } else if (!passwordRegex.test(value)) {
          showErrorMessage(passwordInput, 'passwordError', 'Password must include uppercase, lowercase, number, and special character');
        } else {
          removeErrorMessage(passwordInput.parentNode, 'passwordError');
        }
      });

      passwordInput.addEventListener("keydown", function(e) {
        if (e.key === " ") {
          e.preventDefault();
        }
      });

      passwordInput.addEventListener("input", function() {
        passwordInput.value = passwordInput.value.replace(/\s+/g, "");
      });
    }

    // Mobile Number validation
    function validateMobileNumber(value) {
      const trimmedValue = value.trim();
      if (trimmedValue === '') {
        return { isValid: false, message: 'Mobile number is required' };
      }
      const match = trimmedValue.match(/^\+?(\d+)$/);
      if (!match) {
        return { isValid: false, message: 'Only digits and a leading + are allowed' };
      }
      const digits = match[1];
      if (digits.length < 10 || digits.length > 11) {
        return { isValid: false, message: 'Mobile number must be 10 or 11 digits' };
      }
      if (/^0+$/.test(digits)) {
        return { isValid: false, message: 'Please enter a valid phone number' };
      }
      if (/^1[0]+$/.test(digits)) {
        return { isValid: false, message: 'Please enter a valid phone number' };
      }
      return { isValid: true };
    }

    if (mobileInput) {
      mobileInput.addEventListener('input', function() {
        let value = mobileInput.value;
        value = value.replace(/[^+\d]/g, '').replace(/\+/g, (match, offset) => offset === 0 ? match : '');
        mobileInput.value = value;
        const validation = validateMobileNumber(value);
        if (!validation.isValid) {
          showErrorMessage(mobileInput, 'mobileError', validation.message);
        } else {
          removeErrorMessage(mobileInput.parentNode, 'mobileError');
        }
      });
    }

    // Address validation
    if (addressInput) {
      addressInput.addEventListener('input', function() {
        const value = addressInput.value;
        const addressRegex = /^[a-zA-Z0-9][a-zA-Z0-9\s]*$/;

        if (value === '') {
          showErrorMessage(addressInput, 'addressError', 'Address is required');
        } else if (/^\s/.test(value)) {
          addressInput.value = value.replace(/^\s+/, '').replace(/[^a-zA-Z0-9\s]/g, '');
          showErrorMessage(addressInput, 'addressError', 'Address cannot start with spaces');
        } else if (!addressRegex.test(value)) {
          addressInput.value = value.replace(/[^a-zA-Z0-9\s]/g, '');
          showErrorMessage(addressInput, 'addressError', 'No special characters allowed');
        } else {
          removeErrorMessage(addressInput.parentNode, 'addressError');
        }
      });
    }

    // City validation
    if (cityInput) {
      cityInput.addEventListener('input', function() {
        const value = cityInput.value;
        const cityRegex = /^[a-zA-Z][a-zA-Z0-9\s]*$/;

        if (value === '') {
          showErrorMessage(cityInput, 'cityError', 'City is required');
        } else if (/^\d/.test(value) || /^\s/.test(value)) {
          cityInput.value = value.replace(/^[\d\s]+/, '').replace(/[^a-zA-Z0-9\s]/g, '');
          showErrorMessage(cityInput, 'cityError', 'City must start with a letter');
        } else if (!cityRegex.test(value)) {
          cityInput.value = value.replace(/[^a-zA-Z0-9\s]/g, '');
          showErrorMessage(cityInput, 'cityError', 'No special characters allowed');
        } else {
          removeErrorMessage(cityInput.parentNode, 'cityError');
        }
      });
    }

    // Country validation
    if (countryInput) {
      countryInput.addEventListener('change', function() {
        const value = countryInput.value;
        if (value !== '---') {
          removeErrorMessage(countryInput.parentNode, 'countryError');
        }
      });
    }

    // Zipcode validation
    if (zipcodeInput) {
      zipcodeInput.addEventListener('input', function() {
        const value = zipcodeInput.value;
        const zipcodeRegex = /^[a-zA-Z0-9]*$/;

        if (value === '') {
          showErrorMessage(zipcodeInput, 'zipcodeError', 'Zip code is required');
        } else if (!zipcodeRegex.test(value)) {
          zipcodeInput.value = value.replace(/[^a-zA-Z0-9]/g, '');
          showErrorMessage(zipcodeInput, 'zipcodeError', 'Only letters and numbers allowed');
        } else if (value.length < 4) {
          showErrorMessage(zipcodeInput, 'zipcodeError', 'Zip code must be at least 4 characters');
        } else {
          removeErrorMessage(zipcodeInput.parentNode, 'zipcodeError');
        }
      });
    }

    // Consolidated validation function
    function validateForm(showErrors = false) {
      let isValid = true;

      if (firstNameInput) {
        const value = firstNameInput.value.trim();
        if (value === '') {
          if (showErrors) showErrorMessage(firstNameInput, 'firstNameError', 'First name is required');
          isValid = false;
        } else if (value.length < 3) {
          if (showErrors) showErrorMessage(firstNameInput, 'firstNameError', 'Please enter at least 3 characters');
          isValid = false;
        }
      }

      if (lastNameInput && lastNameInput.value.trim() === '') {
        if (showErrors) showErrorMessage(lastNameInput, 'lastNameError', 'Last name is required');
        isValid = false;
      }

      if (emailInput) {
        const emailValue = emailInput.value.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const atCount = (emailValue.match(/@/g) || []).length;
        if (emailValue === '') {
          if (showErrors) showErrorMessage(emailInput, 'emailError', 'Email is required');
          isValid = false;
        } else if (atCount > 1 || !emailRegex.test(emailValue)) {
          if (showErrors) showErrorMessage(emailInput, 'emailError', 'Please enter a valid email address');
          isValid = false;
        }
      }

      if (passwordInput) {
        const passwordValue = passwordInput.value;
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,40}$/;
        if (passwordValue === '') {
          if (showErrors) showErrorMessage(passwordInput, 'passwordError', 'Password is required');
          isValid = false;
        } else if (passwordValue.length < 8 || passwordValue.length > 40) {
          if (showErrors) showErrorMessage(passwordInput, 'passwordError', 'Password must be 8-40 characters long');
          isValid = false;
        } else if (!passwordRegex.test(passwordValue)) {
          if (showErrors) showErrorMessage(passwordInput, 'passwordError', 'Password must include uppercase, lowercase, number, and special character');
          isValid = false;
        }
      }

      if (mobileInput) {
        const value = mobileInput.value.trim();
        const validation = validateMobileNumber(value);
        if (!validation.isValid) {
          if (showErrors) showErrorMessage(mobileInput, 'mobileError', validation.message);
          isValid = false;
        }
      }

      if (addressInput) {
        const addressValue = addressInput.value;
        const addressRegex = /^[a-zA-Z0-9][a-zA-Z0-9\s]*$/;
        if (addressValue === '') {
          if (showErrors) showErrorMessage(addressInput, 'addressError', 'Address is required');
          isValid = false;
        } else if (/^\s/.test(addressValue)) {
          if (showErrors) showErrorMessage(addressInput, 'addressError', 'Address cannot start with spaces');
          isValid = false;
        } else if (addressValue.length < 5) {
          if (showErrors) showErrorMessage(addressInput, 'addressError', 'Address must be at least 5 characters');
          isValid = false;
        } else if (!addressRegex.test(addressValue)) {
          if (showErrors) showErrorMessage(addressInput, 'addressError', 'No special characters allowed');
          isValid = false;
        }
      }

      if (cityInput) {
        const cityValue = cityInput.value;
        const cityRegex = /^[a-zA-Z][a-zA-Z0-9\s]*$/;
        if (cityValue === '') {
          if (showErrors) showErrorMessage(cityInput, 'cityError', 'City is required');
          isValid = false;
        } else if (/^\d/.test(cityValue) || /^\s/.test(cityValue)) {
          if (showErrors) showErrorMessage(cityInput, 'cityError', 'City must start with a letter');
          isValid = false;
        } else if (!cityRegex.test(cityValue)) {
          if (showErrors) showErrorMessage(cityInput, 'cityError', 'No special characters allowed');
          isValid = false;
        }
      }

      if (countryInput && countryInput.value === '---') {
        if (showErrors) showErrorMessage(countryInput, 'countryError', 'Please select a valid country');
        isValid = false;
      }

      if (zipcodeInput) {
        const zipcodeValue = zipcodeInput.value.trim();
        const zipcodeRegex = /^[a-zA-Z0-9]*$/;
        if (zipcodeValue === '') {
          if (showErrors) showErrorMessage(zipcodeInput, 'zipcodeError', 'Zip code is required');
          isValid = false;
        } else if (!zipcodeRegex.test(zipcodeValue)) {
          if (showErrors) showErrorMessage(zipcodeInput, 'zipcodeError', 'Only letters and numbers allowed');
          isValid = false;
        } else if (zipcodeValue.length < 4) {
          if (showErrors) showErrorMessage(zipcodeInput, 'zipcodeError', 'Zip code must be at least 4 characters');
          isValid = false;
        }
      }

      return isValid;
    }

    // Handle form submission for both submit and button types
    if (submitButton) {
      if (submitButton.type === 'submit') {
        form.addEventListener('submit', function(event) {
          if (!validateForm(true)) {
            event.preventDefault();
          }
        });
      } else if (submitButton.type === 'button') {
        submitButton.addEventListener('click', function() {
          if (validateForm(true)) {
            form.submit();
          }
        });
      }
    }
  });

  // Password reset form validation
  const passwordField = document.querySelector('.reset-password-field');
  const confirmPasswordField = document.querySelector('.reset-password-field-confirm');
  const submitButton = document.querySelector('.reset-password-button');
  const form = submitButton && submitButton.closest('form[action$="/account/reset"]');
  
  let hasInteracted = {
    password: false,
    confirmPassword: false
  };

  if (passwordField && confirmPasswordField && submitButton && form) {
    passwordField.addEventListener('input', function() {
      hasInteracted.password = true;
      validatePasswords();
    });
    
    confirmPasswordField.addEventListener('input', function() {
      hasInteracted.confirmPassword = true;
      validatePasswords();
    });

    function validatePasswords(forceShowErrors = false) {
      const password = passwordField.value;
      const confirmPassword = confirmPasswordField.value;
      let isValid = true;

      passwordField.classList.remove('error');
      confirmPasswordField.classList.remove('error');
      const existingErrors = document.querySelectorAll('.password-error');
      existingErrors.forEach(error => error.remove());

      if ((forceShowErrors || hasInteracted.password) && password.length === 0) {
        showError(passwordField, 'Password is required');
        isValid = false;
      } else if (hasInteracted.password && password.length > 0) {
        const minLength = 8;
        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasNumber = /[0-9]/.test(password);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

        if (password.length < minLength) {
          showError(passwordField, `Password must be at least ${minLength} characters long`);
          isValid = false;
        } else if (!hasUpperCase) {
          showError(passwordField, 'Password must contain at least one uppercase letter');
          isValid = false;
        } else if (!hasLowerCase) {
          showError(passwordField, 'Password must contain at least one lowercase letter');
          isValid = false;
        } else if (!hasNumber) {
          showError(passwordField, 'Password must contain at least one number');
          isValid = false;
        } else if (!hasSpecialChar) {
          showError(passwordField, 'Password must contain at least one special character');
          isValid = false;
        }
      }

      if ((forceShowErrors || hasInteracted.confirmPassword) && confirmPassword.length === 0) {
        showError(confirmPasswordField, 'Please confirm your password');
        isValid = false;
      } else if (hasInteracted.confirmPassword && password !== confirmPassword && confirmPassword.length > 0) {
        showError(confirmPasswordField, 'Passwords do not match');
        isValid = false;
      }

      submitButton.disabled = !isValid;
      return isValid;
    }

    function showError(field, message) {
      field.classList.add('error');
      const errorElement = document.createElement('p');
      errorElement.className = 'password-error validation-error';
      errorElement.textContent = message;
      field.parentNode.appendChild(errorElement);
    }

    if (submitButton.type === 'submit') {
      form.addEventListener('submit', function(event) {
        if (!validatePasswords(true)) {
          event.preventDefault();
        }
      });
    } else if (submitButton.type === 'button') {
      submitButton.addEventListener('click', function() {
        if (validatePasswords(true)) {
          form.submit();
        }
      });
    }
  }

  // Cart note validation
  const noteInput = document.querySelector(".cart-drawer__footer-actions textarea");
  const saveNoteBtn = document.querySelector("dialog-close-button button");

  if (noteInput && saveNoteBtn) {
    noteInput.addEventListener("input", function (e) {
      const noteText = noteInput.value;
      let errorBox = document.querySelector("#cart-note-error");

      if (noteText.length > 300) {
        noteInput.value = noteText.substring(0, 300);
        if (!errorBox) {
          errorBox = document.createElement("div");
          errorBox.id = "cart-note-error";
          errorBox.className = "form-error";
          errorBox.style.color = "red";
          errorBox.style.marginTop = "6px";
          errorBox.textContent = "Note must be less than 300 characters.";
          noteInput.insertAdjacentElement("afterend", errorBox);
        } else {
          errorBox.textContent = "Note must be less than 300 characters.";
        }
        noteInput.classList.add("input--error");
      } else {
        if (errorBox) errorBox.remove();
        noteInput.classList.remove("input--error");
      }
    });
  }

  // Newsletter subscription validation
  const emailInputNews = document.querySelector('.wac-email-news');
  const submitButtonNews = document.querySelector('.subscribe-news');
  const formNews = submitButtonNews && submitButtonNews.closest('form');
  let hasInteractedNews = false;

  if (emailInputNews && submitButtonNews && formNews) {
    function showError(field, message) {
      field.classList.add('error');
      const existingErrors = field.parentNode.querySelectorAll('.validation-error');
      existingErrors.forEach(error => error.remove());
      const errorElement = document.createElement('p');
      errorElement.classList.add('validation-error');
      errorElement.textContent = message;
      field.parentNode.appendChild(errorElement);
    }

    function setButtonAppearance(isValid) {
      if (isValid) {
        submitButtonNews.classList.remove('is-disabled');
        submitButtonNews.removeAttribute('aria-disabled');
      } else {
        submitButtonNews.classList.add('is-disabled');
        submitButtonNews.setAttribute('aria-disabled', 'true');
      }
    }

    function validateEmail(showErrors = false) {
      const email = emailInputNews.value.trim();
      let isValid = true;

      const existingErrors = emailInputNews.parentNode.querySelectorAll('.validation-error');
      existingErrors.forEach(error => error.remove());
      emailInputNews.classList.remove('error');

      if (email.length === 0) {
        if (showErrors) showError(emailInputNews, 'Email id is required');
        isValid = false;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (showErrors || hasInteractedNews) showError(emailInputNews, 'Please enter a valid email address');
        isValid = false;
      }

      setButtonAppearance(isValid);
      return isValid;
    }

    emailInputNews.addEventListener('input', function () {
      this.value = this.value.replace(/[&*()^!%#$]/g, '');
      hasInteractedNews = true;
      validateEmail();
    });

    emailInputNews.addEventListener('paste', function (e) {
      e.preventDefault();
      const pastedText = (e.clipboardData || window.clipboardData).getData('text');
      const sanitizedText = pastedText.replace(/[^a-zA-Z0-9.@_-]/g, '').replace(/\s/g, '');
      const selectionStart = emailInputNews.selectionStart;
      const selectionEnd = emailInputNews.selectionEnd;
      const currentValue = emailInputNews.value;
      // Replace selected text or insert at cursor position
      emailInputNews.value = currentValue.slice(0, selectionStart) + sanitizedText + currentValue.slice(selectionEnd);
      emailInputNews.dispatchEvent(new Event('input'));
    });

    emailInputNews.addEventListener('blur', function () {
      hasInteractedNews = true;
      validateEmail(true);
    });

    if (submitButtonNews.type === 'submit') {
      formNews.addEventListener('submit', function(event) {
        if (!validateEmail(true)) {
          event.preventDefault();
          emailInputNews.focus();
        }
      });
    } else if (submitButtonNews.type === 'button') {
      submitButtonNews.addEventListener('click', function() {
        if (validateEmail(true)) {
          formNews.submit();
        } else {
          emailInputNews.focus();
        }
      });
    }

    validateEmail();
  }
});